import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewChildren,
  OnDestroy,
} from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet, Router } from '@angular/router';
import { ModalService } from '../../services/modal.service';
import { Observable, of, forkJoin, fromEvent, merge } from 'rxjs';
import { debounceTime, distinctUntilChanged, share } from 'rxjs/operators';
import { ItemsPerPageComponent } from '../../components/itemsPerPage.component';
import { I18nTranslator } from '../../i18n/translate';
import { ARBleCampaign, ARBleParcel } from '../../models/agrorendement-ble.model';
import { ARColzaCampaign, ARColzaParcel } from '../../models/agrorendement-colza.model';
import { AROrgeCampaign, AROrgeParcel } from '../../models/agrorendement-orge.model';
import { Campaign } from '../../models/campaign.model';
import { Farm } from '../../models/farm.model';
import { Organisation } from '../../models/organisation.model';
import { Page } from '../../models/page.model';
import { Parcel } from '../../models/parcel.model';
import { ARBleService } from '../../services/agrorendement-ble.service';
import { ARColzaService } from '../../services/agrorendement-colza.service';
import { AROrgeService } from '../../services/agrorendement-orge.service';
import { FarmService } from '../../services/farm.service';
import { KeycloakService } from '../../services/keycloak.service';
import { OrganisationService } from '../../services/organisation.service';
import { PlanningFilterExploitation, PlanningService } from '../../services/planning.service';
import { showErrorMessage, toNull, toNumber } from '../../utils/utils';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PaginationModule } from 'ngx-bootstrap/pagination';

@Component({
  standalone: true,
  selector: 'planning-select-exploitation',
  templateUrl: './planning-exploitation.component.html',
  styleUrls: ['planning.component.scss'],
  imports: [RouterLink, RouterLinkActive, RouterOutlet, ItemsPerPageComponent, TranslatePipe, CommonModule, FormsModule, PaginationModule],
  providers: [PlanningService, FarmService],
})
export class PlanningSelectExploitation implements OnInit, AfterViewInit, OnDestroy {
  @Input()
  culture: string;

  @Input()
  passage: string;

  error: any;
  @ViewChild('filter') filterElement: ElementRef;
  @ViewChild('filterConseiller') filterElementConseiller: ElementRef;
  @ViewChild('filterPostal') filterElementPostal: ElementRef;
  @ViewChildren('farmCheckbox') farmCheckboxes: any;

  public rows: Array<any> = [];
  public farmIsCompleted: Map<number, boolean> = new Map<number, boolean>();

  @Output()
  organisationEvent = new EventEmitter<Array<Organisation>>();
  @Output()
  organisationChoice = new EventEmitter<any>();
  public page: number = 1;
  public itemsPerPage: number = 25;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;

  public filter: string = '';
  public filterPostal: string = '';
  public filterConseiller: string = '';
  public campaignFilter: number;
  public showRef: boolean;
  public isAdmin: boolean;
  public isSector: boolean;
  public isManager: boolean;
  public isAdvisor: boolean;
  public isFarmer: boolean;
  public isNegoce: boolean;
  public farmIdFromParcel: Set<number>;
  public parcelsTmp: Array<any> = [];
  public alreadyGet: Set<number> = new Set<number>();
  public lastIdFarmList: number[];
  lengthAllParcels: number;

  @ViewChild('checkboxAll') checkboxAll: any;

  organisationFilter: number = null;
  organisations: Organisation[];
  @ViewChild('termOrganisationFilter') termOrganisationFilter: ElementRef;
  static filterToApply: PlanningFilterExploitation;

  campaignsOrge: AROrgeCampaign[];
  campaignsBle: ARBleCampaign[];
  campaignsColza: ARColzaCampaign[];

  @Input('farmIds')
  checkedFarmIds: Set<number>;

  @Input('farmIdMapping')
  farmIdsNames: Map<number, string>;

  @Input()
  orderItem: Set<Farm>;

  constructor(
    private planningService: PlanningService,
    private farmService: FarmService,
    private router: Router,
    private organisationService: OrganisationService,
    private colzaService: ARColzaService,
    private bleService: ARBleService,
    private orgeService: AROrgeService,
    private i18nTranslator: I18nTranslator,
    private modal: ModalService,
    private cdr: ChangeDetectorRef,
  ) {
    this.showRef =
      KeycloakService.auth.authz.hasRealmRole('ROLE_ADMIN') || KeycloakService.auth.authz.hasRealmRole('ROLE_SECTOR');
    this.isAdmin = KeycloakService.auth.authz.hasRealmRole('ROLE_ADMIN');
    this.isSector = KeycloakService.auth.authz.hasRealmRole('ROLE_SECTOR');
    this.isManager = KeycloakService.auth.authz.hasRealmRole('ROLE_MANAGER');
    this.isAdvisor = KeycloakService.auth.authz.hasRealmRole('ROLE_ADVISOR');
    this.isFarmer = KeycloakService.auth.authz.hasRealmRole('ROLE_FARMER');
    this.isNegoce = KeycloakService.auth.authz.hasRealmRole('ROLE_NEGOCE');
  }

  ngOnInit() {
    const obs1 = this.getBleCampaigns();
    const obs2 = this.getOrgeCampaigns();
    const obs3 = this.getColzaCampaigns();
    const obs4 = this.getOrganisations();

    forkJoin([obs1, obs2, obs3, obs4]).subscribe((data: Array<any>) => {
      let temp: any;
      if (this.culture === 'ble') {
        temp = data[0];
        this.campaignFilter = temp[0].id;
      } else if (this.culture === 'orge') {
        temp = data[1];
        this.campaignFilter = temp[0].id;
      } else if (this.culture === 'colza') {
        temp = data[2];
        this.campaignFilter = temp[0].id;
      }
      this.campaignFilter;
      this.updateUIWithFilters();
    });
    this.onChangeTable();
  }

  ngAfterViewInit() {
    // TODO améliorer => pas de debounce quand clearFilter a été appelé
    const observables = new Array<Observable<{}>>();
    const obs2 = fromEvent(this.filterElement.nativeElement, 'keyup').pipe(debounceTime(300), distinctUntilChanged());
    const obs4 = fromEvent(this.filterElementPostal.nativeElement, 'keyup').pipe(
      debounceTime(300),
      distinctUntilChanged(),
    );

    observables.push(obs2, obs4);

    if (!this.isFarmer) {
      const obs5 = fromEvent(this.filterElementConseiller.nativeElement, 'keyup').pipe(
        debounceTime(300),
        distinctUntilChanged(),
      );
      observables.push(obs5);
      obs5.subscribe((term) => (this.filterConseiller = <string>this.filterElementConseiller.nativeElement.value));
    }
    if (this.isAdmin || this.isNegoce) {
      const obs6 = fromEvent(this.termOrganisationFilter.nativeElement, 'change');
      observables.push(obs6);
    }

    obs2.subscribe((term) => (this.filter = <string>this.filterElement.nativeElement.value));
    obs4.subscribe((term) => (this.filterPostal = <string>this.filterElementPostal.nativeElement.value));

    merge(...observables)
      .pipe(debounceTime(10))
      .subscribe((term: any) => {
        this.updateFilters();
      });
  }

  ngOnDestroy() {}

  //Event GET
  onChangeItemsPerPage(newValue: number) {
    // si itemsPerPage change et que page change ; par exemple page trop
    // grande pour le nombre d'éléments totaux => refresh de la pagination
    // mais si page reste identique, il faut le faire explicitement
    const page = this.page;
    this.cdr.detectChanges();
    if (page === this.page) {
      this.onChangeTable();
    }
  }

  onChangeTable(page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    const pageNumber = page.page;
    this.handleListParcel(pageNumber, 'name', 'asc', PlanningSelectExploitation.filterToApply);
  }

  getFarms(pageIndex: number, sortColumnName: string, sortColumnOrder: string, filter: PlanningFilterExploitation) {}

  handleListParcel(
    pageIndex: number,
    sortColumnName: string,
    sortColumnOrder: string,
    filter: PlanningFilterExploitation,
  ) {
    /*     this.planningService.getFarms(pageIndex, this.itemsPerPage,
      this.culture, this.passage, this.campaignFilter, null, sortColumnName, sortColumnOrder, filter, null
    ).subscribe((result: any) => {

    this.rows = new Array<Farm>();
      this.handlePage(result)
    },e =>{this.handleError(e);}) */
  }

  handlePage(page: Page<any>) {
    this.rows = page.content;
    this.numPages = page.totalPages;
    this.length = page.totalElements;
    this.planningService
      .getParcelsFarms(
        this.culture,
        this.passage,
        this.campaignFilter,
        this.rows.map((el) => el.id),
        null,
        null,
        null,
        null,
        false,
      )
      .subscribe(
        (parcels: Parcel[]) =>
          this.rows.forEach((el) => {
            this.checkDate(parcels.filter((parcel) => parcel.farm.id === el.id));
          }),
        (e) => {
          this.handleError(e);
        },
      );
  }

  handleError(e: any) {
    if (e.status == 400) {
      this.modal
        .alert(this.i18nTranslator.translate('planning.exploitations.error.noParcelles'))
        .then(() => this.router.navigate(['/planning']));
    } else {
      this.modal.alert(this.i18nTranslator.translate('planning.exploitations.error.exploitations'));
    }
  }

  handleErroWhitMsg(error: any, msg: string) {
    if (error.status === 401) {
      showErrorMessage(this.modal, this.i18nTranslator.translate('planning.error.unauthorized'));
    } else {
      console.error(error);

      // generic error message
      showErrorMessage(this.modal, msg);
    }
  }

  //Gestion Filters
  updateUIWithFilters() {
    if (PlanningSelectExploitation.filterToApply) {
      this.filter = PlanningSelectExploitation.filterToApply.prefixExploitation;
      this.filterElement.nativeElement.value = this.filter;
      this.filterPostal = PlanningSelectExploitation.filterToApply.postalCode;
      this.filterElementPostal.nativeElement.value = this.filterPostal;

      if (!this.isFarmer && this.filterElementConseiller) {
        this.filterConseiller = PlanningSelectExploitation.filterToApply.prefixConseiller;
        this.filterElementConseiller.nativeElement.value = this.filterConseiller;
      }
      if (this.isAdmin || this.isNegoce) {
        this.organisationFilter = toNumber(PlanningSelectExploitation.filterToApply.organisationId);
      }
    }
  }

  clearFilters() {
    this.resetFilters();
    this.updateFilters();
  }

  resetFilters() {
    this.filter = null;
    this.filterPostal = null;
    this.filterConseiller = null;
    this.organisationFilter = null;

    this.filterElement.nativeElement.value = null;
    this.filterElementPostal.nativeElement.value = null;

    if (this.isAdmin || this.isNegoce) {
      this.termOrganisationFilter.nativeElement.value = null;
    }
    if (!this.isFarmer) {
      this.filterElementConseiller.nativeElement.value = null;
    }
  }

  resetFilterToApply() {
    PlanningSelectExploitation.filterToApply = {
      prefixExploitation: this.filter,
      prefixConseiller: this.filterConseiller,
      postalCode: this.filterPostal,
      organisationId: toNull(this.organisationFilter),
    };
  }

  updateFilters() {
    this.resetFilterToApply();
    // reset la page à la première et update la table
    // FIXME faire mieux : suspendre le traitement des changements ?
    if (this.page === 1) {
      this.organisationChoice.emit(this.organisationFilter ? this.organisationFilter : 'null');
      this.onChangeTable();
    } else {
      // le biding (pagechanged) du contrôle de pagination va appeler onChangeTable
      this.page = 1;
      this.organisationChoice.emit(this.organisationFilter ? this.organisationFilter : 'null');
    }
    this.clearCheckboxes();
  }

  //Check / modifier le front
  isFarmChecked(farm: Farm): boolean {
    return this.checkedFarmIds.has(farm.id);
  }

  checkDate(parcels: Parcel[]) {
    let dateCompleted = true;
    let parcelToChange: any;
    parcels.forEach((parcel) => {
      if (this.culture === 'ble') {
        parcelToChange = parcel as ARBleParcel;
        switch (this.passage) {
          case 'BLET1':
            parcelToChange.orderItem.t1_date_livraison ? (dateCompleted = dateCompleted) : (dateCompleted = false);
            this.farmIsCompleted.set(parcels[0].farm.id, dateCompleted);
            break;
          case 'BLET2':
            parcelToChange.orderItem.t2_date_livraison ? (dateCompleted = dateCompleted) : (dateCompleted = false);
            this.farmIsCompleted.set(parcels[0].farm.id, dateCompleted);
            break;
          case 'BLEDN':
            parcelToChange.orderItem.dn_date_livraison ? (dateCompleted = dateCompleted) : (dateCompleted = false);
            this.farmIsCompleted.set(parcels[0].farm.id, dateCompleted);
            break;
          case 'BLET3':
            parcelToChange.orderItem.t3_date_livraison ? (dateCompleted = dateCompleted) : (dateCompleted = false);
            this.farmIsCompleted.set(parcels[0].farm.id, dateCompleted);
            break;
        }
      } else if (this.culture === 'orge') {
        parcelToChange = parcel as AROrgeParcel;
        switch (this.passage) {
          case 'ORGET1':
            if (!parcelToChange.orderItem.t1_date_livraison) {
              dateCompleted = false;
            }
            this.farmIsCompleted.set(parcels[0].farm.id, dateCompleted);
            break;
          case 'ORGET2':
            parcelToChange.orderItem.t2_date_livraison ? (dateCompleted = dateCompleted) : (dateCompleted = false);
            this.farmIsCompleted.set(parcels[0].farm.id, dateCompleted);
            break;
          case 'ORGET3':
            parcelToChange.orderItem.t3_date_livraison ? (dateCompleted = dateCompleted) : (dateCompleted = false);
            this.farmIsCompleted.set(parcels[0].farm.id, dateCompleted);
            break;
        }
      } else if (this.culture === 'colza') {
        parcelToChange = parcel as ARColzaParcel;
        switch (this.passage) {
          case 'COLZAEH':
            parcelToChange.orderItem.eh_date_livraison ? (dateCompleted = dateCompleted) : (dateCompleted = false);
            this.farmIsCompleted.set(parcels[0].farm.id, dateCompleted);
            break;
          case 'COLZASH':
            parcelToChange.orderItem.sh_date_livraison ? (dateCompleted = dateCompleted) : (dateCompleted = false);
            this.farmIsCompleted.set(parcels[0].farm.id, dateCompleted);
            break;
        }
      }
    });
  }

  isCompleted(row: Farm) {
    if (this.farmIsCompleted) {
      return this.farmIsCompleted.get(row.id);
    } else {
      return false;
    }
  }

  //Gestion des checkboxs
  onCheckboxClicked(index: number) {
    const checkboxes = this.farmCheckboxes.toArray().map((x: any) => x.nativeElement);
    const farm = this.rows[index];
    const checkbox = checkboxes[index];
    if (checkbox.checked) {
      this.checkedFarmIds.add(farm.id);
      this.farmIdsNames.set(farm.id, farm.name);
    } else {
      this.checkedFarmIds.delete(farm.id);
      this.farmIdsNames.delete(farm.id);
    }
  }

  onCheckboxAllClicked() {
    /*     if (this.checkboxAll.nativeElement.checked) {
      this.planningService.getFarms(0,1000000, this.culture, this.passage, this.campaignFilter, null, null, null, PlanningSelectExploitation.filterToApply, null).subscribe((x: any) => {
        this.lengthAllParcels = x.content.length;
        for (let idx of x.content) {
          this.checkedFarmIds.add(idx.id);
          this.farmIdsNames.set(idx.id, idx.name);
        }
        // pas de modèle : on coche à la main
        let checkboxes = this.farmCheckboxes.toArray().map((y: any) => y.nativeElement);
        for (let i = 0; i < checkboxes.length; i++) {
          let checkbox = checkboxes[i];
          checkbox.checked = true;
        }
      }, (error: any) => {
        this.handleErroWhitMsg(error, this.i18nTranslator.translate("planning.exploitations.error.selectExploitations"));
      });
    } else {
      this.clearCheckboxes();
    } */
  }

  clearCheckboxes() {
    this.lengthAllParcels = undefined;
    this.checkboxAll.nativeElement.checked = false;
    // decoche tout
    this.checkedFarmIds.forEach((x) => this.farmIdsNames.delete(x));
    this.checkedFarmIds.clear();

    // pas de modèle : on décoche à la main
    const checkboxes = this.farmCheckboxes.toArray().map((x: any) => x.nativeElement);
    for (const checkbox of checkboxes) {
      checkbox.checked = false;
    }
  }

  isCheckboxAllChecked(): boolean {
    return this.lengthAllParcels === this.checkedFarmIds.size;
  }

  //Get a l'initialisation
  getOrganisations(): Observable<Organisation[]> {
    if (this.isAdmin || this.isNegoce) {
      const obs = this.organisationService.getOrganisations().pipe(share());
      obs.subscribe({
        next: (orgs) => {
          const orga = orgs.sort((a, b) => a.name.localeCompare(b.name));
          this.organisations = orga;
          this.organisationEvent.emit(orga);
        },
      });
      return obs;
    } else {
      return of([]);
    }
  }

  getBleCampaigns(): Observable<ARBleCampaign[]> {
    const obs = this.bleService.getCampaigns().pipe(share());
    obs.subscribe(
      (campaigns) => {
        this.campaignsBle = campaigns.sort(Campaign.compare).reverse();
      },
      (err) => this.handleErroWhitMsg(err, this.i18nTranslator.translate('planning.error.campagne')),
    );
    return obs;
  }

  getColzaCampaigns(): Observable<ARColzaCampaign[]> {
    const obs = this.colzaService.getCampaigns().pipe(share());
    obs.subscribe(
      (campaigns) => {
        this.campaignsColza = campaigns.sort(Campaign.compare).reverse();
      },
      (err) => this.handleErroWhitMsg(err, this.i18nTranslator.translate('planning.error.campagne')),
    );
    return obs;
  }

  getOrgeCampaigns(): Observable<AROrgeCampaign[]> {
    const obs = this.orgeService.getCampaigns().pipe(share());
    obs.subscribe(
      (campaigns) => {
        this.campaignsOrge = campaigns.sort(Campaign.compare).reverse();
      },
      (err) => this.handleErroWhitMsg(err, this.i18nTranslator.translate('planning.error.campagne')),
    );
    return obs;
  }
}
